/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Memory_DescriptionInputs */



/**
* | output |
* | --- |
* | "Uno notes a few durable details from your conversations so its answers fit how you work. Delete anything you would rather it forgot." |
*
* @param {Uno_Memory_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_memory_description = /** @type {((inputs?: Uno_Memory_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Memory_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Uno merkt sich einige dauerhafte Details aus deinen Unterhaltungen, damit seine Antworten zu deiner Arbeitsweise passen. Lösche alles, was Uno vergessen soll.")
	return /** @type {LocalizedString} */ ("Uno notes a few durable details from your conversations so its answers fit how you work. Delete anything you would rather it forgot.")
});